import AnchorErrorTracking from '../../../../AnchorErrorTracking';

const addErrorEventListeners = () => {
  window.addEventListener('error', event => {
    const { message, filename, lineno, colno, error } = event;
    const errorMessage = {
      message,
      line: lineno,
      filename,
      column: colno,
      errorObj: JSON.stringify(error),
    };
    AnchorErrorTracking.captureException({
      error,
      extraInformation: errorMessage,
    });
  });
};

export { addErrorEventListeners };
